export const getPlainText = (text?: string) => {
  const doc = new DOMParser().parseFromString(text ?? '', 'text/html');
  return doc.body.textContent?.trim() ?? '';
};
